/**
 * Created by @stsmedia 😎
 */

/**
 * @author Stefan Schmidt
 * @description Simple hash function used for hashing sensitive data for analytics.
 * @param str - The string to hash.
 * @param targetLength - The target length of the hash.
 * @returns The hashed string.
 */
export const customHash = (str: string, targetLength: number = 6): string => {
  let hash = 0;

  if (str.length === 0) return '0'.repeat(targetLength);

  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash; // Convert to 32-bit integer
  }

  // Convert to positive and pad to desired length
  const hashStr = Math.abs(hash).toString(36);

  return hashStr.padStart(targetLength, '0').substring(0, targetLength);
};
